module.exports = {"id":null,"no_dok":null,"tgl_dok":null,"nomor_lengkap":null,"lokasi":null,"declare_flags":["IMPOR_UNTUK_DIPAKAI"],"npwp_nib":null,"no_flight":null,"kd_airline":null,"tgl_kedatangan":null,"kd_pelabuhan_asal":null,"kd_pelabuhan_tujuan":null,"jumlah_detail":0,"jml_bagasi_dibawa":0,"jml_bagasi_tdk_dibawa":0,"jml_anggota_keluarga":0,"pembebasan":500,"pph_tarif":7.5,"last_status":null,"is_locked":false,"penumpang_id":null,"pelabuhan_asal":{"data":null},"pelabuhan_tujuan":{"data":null},"penumpang":{"data":null},"ndpbm":{"data":{"id":null}},"dokkap":{"data":[]},"billing":{"data":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/defaultCd.json
// module id = 9iof
// module chunks = 1